import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoodBetween = (props) => /* @__PURE__ */ _jsxs("svg", {
	preserveAspectRatio: "none",
	width: "100%",
	height: "100%",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 104 104",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group 15888",
		children: [
			/* @__PURE__ */ _jsx("foreignObject", {
				x: -32.5,
				y: -32.5,
				width: 169,
				height: 169,
				children: /* @__PURE__ */ _jsx("div", {
					xmlns: "http://www.w3.org/1999/xhtml",
					style: {
						backdropFilter: "blur(16.25px)",
						clipPath: "url(#bgblur_0_0_18_clip_path)",
						height: "100%",
						width: "100%"
					}
				})
			}),
			/* @__PURE__ */ _jsx("circle", {
				id: "Ellipse 189",
				"data-figma-bg-blur-radius": 32.5,
				cx: 52,
				cy: 52,
				r: 52,
				fill: "var(--fill-0, #DFCBF5)",
				fillOpacity: .1
			}),
			/* @__PURE__ */ _jsx("g", { id: "Rectangle 1240" }),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector 86",
				d: "M33 76H71",
				stroke: "var(--stroke-0, #DFCBF5)",
				strokeWidth: 3,
				strokeLinecap: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "bgblur_0_0_18_clip_path",
		transform: "translate(32.5 32.5)",
		children: /* @__PURE__ */ _jsx("circle", {
			cx: 52,
			cy: 52,
			r: 52
		})
	}) })]
});
export default SvgMoodBetween;
